import React, { useState } from "react";
import { Helmet } from "react-helmet";
import Dropdown from "../components/DropDown";
import "./styles.css";
import { Dropdowns, IDrops } from "./dropDownData";

/**
 * Render react app with redux store
 */
interface IProps {}

const Calculators: React.FC<IProps> = () => {
  const [url, setUrl] = useState("");
  const [loading, setLoading] = useState(false);
  const [selectedTab, setSelectedTab] = useState(" ");

  return (
    <React.Fragment>
      <Helmet>
        <meta charSet="utf-8" />
        <title>Free Matched Betting Reload Offers & Resources</title>
      </Helmet>
      <div className="p-1">
        <iframe
          src="https://imperialwealth.com/betting/embed/calculators"
          style={{ width: "100%", height: "100vh" }}
        ></iframe>
      </div>
    </React.Fragment>
  );
};

export default Calculators;
